import React, { useCallback, useRef } from 'react';
import { View, TextInput, StyleSheet } from 'react-native';
import Theme from 'Theme';
import Icon from '../Icon';

// TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
// eslint-disable-next-line react/prefer-stateless-function
const SearchBox = ({
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/prop-types
    value,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/prop-types
    onSearch,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/prop-types
    onSearchCancel
}) => {
    const inputRef = useRef(null);

    const onChangeText = useCallback(
        (textValue) => {
            if (textValue === '') {
                if (onSearchCancel) onSearchCancel(inputRef);
            } else if (onSearch) {
                onSearch(textValue, inputRef);
            }
        },
        [inputRef]
    );

    return (
        <View testID="search_box">
            <View style={styles.container}>
                <form autoComplete="off" method="post" action="">
                    <input
                        autoComplete="false"
                        name="hidden"
                        type="text"
                        style={{ display: 'none' }}
                    />
                    <TextInput
                        ref={inputRef}
                        style={styles.input}
                        autoComplete="off"
                        id="search-field"
                        underlineColorAndroid="transparent"
                        onChangeText={onChangeText}
                        value={value}
                        testID="search_input"
                    />
                </form>
                {Boolean(value) && (
                    <Icon
                        name="cancel"
                        style={styles.icon}
                        onPress={() => {
                            if (onSearchCancel) {
                                onSearchCancel();
                            }
                        }}
                    />
                )}
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        borderWidth: 1,
        borderColor: Theme.secondaryButtonBorderColor,
        borderRadius: 4,
        flexDirection: 'row',
        width: 160
    },
    input: {
        padding: 8,
        margin: 0,
        width: '100%',
        height: 28,
        color: Theme.primaryTextColor
    },
    icon: {
        width: 20,
        height: 20,
        marginRight: 5,
        marginLeft: 10,
        marginTop: 4
    }
});

export default SearchBox;
